import { createContext, Dispatch, SetStateAction } from 'react';
import { Entity } from '../../../../../../@Api/Model/Implementation/Entity';

type State<S> = [S | undefined, Dispatch<SetStateAction<S | undefined>>];

export default createContext<State<Entity>>([ undefined, () => {} ]);
